import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import Loader from '../components/Loader';
import { ErrorFlash } from '../components/Flash';
import { useRequestAsync } from '../api/client';
import LoginPage from '../components/LoginPage';

interface Props extends RouteComponentProps<any> {}

type PasswordParams = {
  password: string;
  confirm: string;
};

export default function ForgotPassword(props: Props) {
  const [password, setPassword] = React.useState<string>(null);
  const [confirmation, setConfirmation] = React.useState<string>(null);
  const [state, submit] = useRequestAsync((data: PasswordParams) => ({
    url: '/users/reset/' + props.match.params.token,
    method: 'POST',
    body: JSON.stringify(data),
  }));

  if (state.complete && !state.error) {
    return (
      <LoginPage {...props}>
        <div className="pa4 black-80 ml-auto mr-auto w-70-ns">
          <h3 className="f3 f2-ns lh-title ma0 mb2 green">
            All done!
          </h3>
          <small className="f6 black-60 db mb3 mb4-ns lh-copy">
            You can now login to Filtru using your new password.
          </small>
        </div>
      </LoginPage>
    );
  }

  return (
    <LoginPage {...props}>
      <form
        className="pa4 black-80 ml-auto mr-auto w-70-ns"
        method="POST"
        onSubmit={(e) => {
          e.preventDefault();
          submit({ password, confirm: confirmation });
        }}
      >
        <h3 className="f3 f2-ns lh-title ma0 mb2 black">
          Enter your new password
        </h3>
        <small className="f6 black-60 db mb3 mb4-ns lh-copy">
          Set your new password to login to Filtru.
        </small>
        {state.error && <ErrorFlash error={state.error} />}
        {state.loading ? (
          <Loader />
        ) : (
          <React.Fragment>
            <div className="mv3-ns measure-wide">
              <label
                htmlFor="password"
                className="f6 b db mb2 ttu black-50 fw6"
              >
                Password
              </label>
              <input
                id="password"
                name="password"
                className="input-reset ba b--black-20 pa2 mb2 db w-100"
                type="password"
                required
                defaultValue={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <div className="mv3-ns measure-wide">
              <label
                htmlFor="passwordConfirmation"
                className="f6 b db mb2 ttu black-50 fw6"
              >
                Repeat Password
              </label>
              <input
                id="passwordConfirmation"
                name="passwordConfirmation"
                className="input-reset ba b--black-20 pa2 mb2 db w-100"
                type="password"
                required
                defaultValue={confirmation}
                onChange={(e) => setConfirmation(e.target.value)}
              />
            </div>
            <button
              className="mv3 mv4-ns db link gold f3 b bw0 bg-ui-white-1 tl pa0 dim pointer bg-animate"
              type="submit"
            >
              Continue →
            </button>
          </React.Fragment>
        )}
      </form>
    </LoginPage>
  );
}
